import axios from "axios";
import { Store } from "vuex";
import { IKpiInfo } from "@/shared/model/global/kpi-info.model";
import CEUser from "@/shared/model/user-management/user-create-edit.model";
import { IUser } from "@/shared/model/user-management/user.model";
import { ICompany } from "@/shared/model/user-management/company.model";
import { IUserForList } from "@/shared/model/user-management/user-for-list.model";

const baseApiUrl = "api/back-office";

export default class BackOfficeService {
  constructor(private store: Store<any>) {}

  public getCEUserById(id): Promise<IUser> {
    return new Promise<CEUser>(function (resolve, reject) {
      axios
        .get(`${baseApiUrl}/get-ceuser/${id}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public createEditUser(entity: CEUser): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/create-edit-user`, entity)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllDirectors(): Promise<IUserForList[]> {
    return new Promise<IUserForList[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/directors`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getSuiviInfos(dates): Promise<IKpiInfo[]> {
    return new Promise<IKpiInfo[]>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/get-suivi-infos`, dates)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public switchActivationStatusForUser(ufl: IUserForList): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/switch-activation-status-for-user`, ufl)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public get360Recaps(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-360-recaps`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }


  public get360RecapsWithFilters(currentPage,searchText,startDate,endDate,searchAccountType): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-360-recaps-filters`,{
          params: {
            searchText: searchText,
            currentPage: currentPage,
            startDate:startDate,
            endDate:endDate,
            searchAccountType:searchAccountType
          }
        })
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  
  public count360RecapsWithFilters(searchText): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/count-360-recaps-filters`,{
          params: {
            searchText: searchText
          }
        })
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getEsgRecaps(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-esg-recaps`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  

  public getEsgRecapsWithFilters(currentPage,searchText,startDate,endDate,searchAccountType): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-esg-recaps-filters`,{
          params: {
            currentPage: currentPage,
            searchText: searchText,
            startDate:startDate,
            endDate:endDate,
            searchAccountType:searchAccountType
          }
        })
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  } 

  public countEsgRecapsWithFilters(searchText): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/count-esg-recaps-filters`,{
          params: {
            searchText: searchText
          }
        })
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public uploadLogoImage(entity): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/upload-logo-image`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public generateTempLink(entity): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/generate-temp-link`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public get360RecapsForUser(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-360-recaps-for-user/${id}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getEsgRecapsForUser(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-esg-recaps-for-user/${id}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllCompanies(): Promise<Array<ICompany>> {
    return new Promise<Array<ICompany>>(function (resolve, reject) {
      axios
        .get(`${baseApiUrl}/get-all-companies`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getAllParameters(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/parameters`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public toggleParameterAuthorized(param): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/parameter/` + param.id)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getMultiConseillers(): Promise<IUserForList[]> {
    return new Promise<IUserForList[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/multi-conseillers`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
